import { Avatar, Box, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleAlert } from 'Images';

export const IntroBubbleInfo = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.CompassRights
  ).introBubbleInfo;

  return (
    <Box mt={'-24px'}>
      <Typography variant={'body3'}>{dictionary.lineOne}</Typography>
      <Stack
        direction='row'
        borderRadius='8px'
        border={'1px solid'}
        borderColor={'purple2.shade_200'}
        bgcolor={'purple2.shade_100'}
        padding={isDesktop ? '16px 16px 18px' : '12px'}
        role='note'
        mt={'32px'}
        justifyContent={isDesktop ? undefined : 'center'}
      >
        <Avatar
          alt=''
          src={PurpleAlert}
          sx={{ width: '24px', height: '24px', marginTop: '2px' }}
        />
        <Stack
          margin='0 0 0 6px'
          color={'text.secondary'}
          maxWidth={isDesktop ? undefined : '26ch'}
        >
          <Typography variant={'body6'}>{dictionary.lineTwo}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
